import React, { PureComponent } from 'react';
import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer
} from '../../components/ui';

import Image from '../../../../containers/assets/peer-feedback-cultivating-leadership.png'

class CareerPathwayStep1 extends PureComponent {
  render() {
    return (
      <Wrapper>
        <PreTitle>Leadership Pathway</PreTitle>
        <Title>Cultivating Leadership & Teamwork Skills</Title>
        <Text>
          <p>This section provides information about leadership and teamwork experiences that you have explored in the game and how you can further cultivate these skills.</p>
        </Text>
        <ContentContainer>
          <img src={Image} alt='' />
        </ContentContainer>
      </Wrapper>
    );
  }

}

export default CareerPathwayStep1;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/career-pathway/step1.js